// used for page-load and page-segment-load events
export const FF_ALLOWLIST_FOR_PERF_METRICS: string[] = [
	'confluence.ssr.page-statuses',
	'confluence_react_streaming',
	'confluence_frontend_vc_observer_initialization',
	'confluence_frontend_remove_comments_placeholder',
	'enable_loadable_placeholder_for_legacy_macros',
	'edition_awareness_standard_upsell_confluence_ab',
	'edition_awareness_standard_upsell_confluence_ab_fg',
	'platform-ssr-table-resize',
	'confluence_frontend_content_wrapper',
	'content_early_connect_iframe_initialization',
	'confluence_emit_v3_debug_data',
	'nav4_confluence_global_links',
	'confluence_use_atlaspack',
	'confluence_use_atlaspack_variant_1',
	'confluence_use_atlaspack_variant_2',
	'platform_ufo_exclude_3p_extensions_from_ttvc',
	'confluence_frontend_v2_removal',
	'confluence_frontend_statlas_redirect',
	'confluence_frontend_enable_react_dom_context_patch',
	'confluence_exclude_children_macro_from_blocklist',
	'confluence_use_react-compiler',
	'confluence_enable_2p_toolbar_apps',
	'confluence_ssr_cookie_banner_black_space',
	'cc-engagement-omnibar-hide-inline-comments',
	'cc-engagement-omnibar-hide-highlight-actions',
	'cc-engagement-omnibar-hide-sidebar-flyout',
];

// In order to reduce BM event payload size, include a FF in the BM payload only if it's in the allow list.
// The following FFs will be included in all types of BM event.
export const ALLOWLIST_FFS_CUSTOM_EVENTS: never[] = [];
